var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { BwElement } from './base/bw-element.js';
// CSS lives in packages/ui-components/src/styles/bw-pinned-cell.css —
// consumers must import it (Storybook preview, web SPA, desktop renderer).
// Lit `static styles` is a no-op in light DOM (no shadowRoot.adoptedStyleSheets).
// See packages/ui-components/README.md "Light DOM + CSS prefix" for full convention.
let BwPinnedCell = class BwPinnedCell extends BwElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.kind = '';
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.hasAttribute('role'))
            this.setAttribute('role', 'group');
    }
    render() {
        return html `
      <div class="bw-pc-header">${this.label}</div>
      <div class="bw-pc-body">
        <slot></slot>
      </div>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], BwPinnedCell.prototype, "label", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwPinnedCell.prototype, "kind", void 0);
BwPinnedCell = __decorate([
    customElement('bw-pinned-cell')
], BwPinnedCell);
export { BwPinnedCell };
//# sourceMappingURL=bw-pinned-cell.js.map